<template>
    <div class="data-table-sorting-icons">
        <div class="icon asc"></div>
        <div class="icon desc"></div>
    </div>
</template>

<script>
export default {
    name: "DataTableSortingIcon",
}
</script>
<style src="./SortingIcon.scss" lang="scss"></style>
